import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Discussions_ModuleContextService } from './Discussions.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Discussions_discussion_card_ComponentContextService {
  private readonly moduleContext: Discussions_ModuleContextService;

  constructor(moduleContext: Discussions_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'discussion_card',
      type: ComponentType.card
    }
  }
}